<template>
  <div class="createFeuerwehr">
    <img class="flame" src="@/assets/Flamme.png">
    <button class="back fa" @click="this.$emit('registerBack')">&#xf104;</button>
    <h1>Feuerwehr hinzufügen</h1>
    <input v-model="name" ref="name" type="text" id="name" name="name" placeholder="Bezeichnung">
    <div class="map">
        <FeuerwehrAuswahl @locationSelected="this.locationSelected" :setMarkerActive="true"/>
    </div>
    <p class="standortWaehlen">Wählen Sie auf der Karte den Standort Ihrer Feuerwehr</p>

    <button class="createFeuerwehrButton" @click="createFeuerwehr()">Feuerwehr anlegen</button>

    <p class="hasAccount">Feuerwehr existiert schon? <a class="hasAccountLink" @click="this.$emit('registerBack')">Benutzer anlegen</a></p>
  </div>
</template>
  
<script>
import FeuerwehrAuswahl from './FeuerwehrAuswahl.vue';
import Swal from 'sweetalert2';
import axios from 'axios';
import CryptopJS from 'crypto-js';

export default {
    name: 'CreateFeuerwehr',
    components: {
        FeuerwehrAuswahl
    },
    data() {
      return{
        laengengrad: null,
        breitengrad: null,
        ort: null,
        position: null,
        county: null,
        city: null,
        name: null
      }
    },
    methods: {
        locationSelected(position){
            this.laengengrad = position.lng;
            this.breitengrad = position.lat;
            this.ort = position.address.postcode + ' ' + position.address.city;
            this.county = position.address.county;
            this.position = position;
            this.city = position.address.city;
        },
        async createFeuerwehr(){
          // Automatisch nach dem Standort der auf der Karte gewählt wurde den Landkreis holen und mit eintragen
          const feuerwehrData = {
            name: this.name,
            positionX: this.breitengrad,
            positionY: this.laengengrad,
            konvKey: this.encryptString(this.city + this.laengengrad + this.breitengrad),
            landkreisID: await this.getLandkreisID()
          };

          if(feuerwehrData.name === null || feuerwehrData.name === ''){
            Swal.fire("Fehler bei den Feuerwehrdaten", "Bitte geben Sie einen Namen für die Feuerwehr ein", "error");
            return;
          }

          if(feuerwehrData.positionX === null || feuerwehrData.positionY === null){
            Swal.fire("Fehler bei den Feuerwehrdaten", "Bitte wählen Sie einen Standort auf der Karte aus", "error");
            return;
          }

          if(feuerwehrData.landkreisID === null){
            Swal.fire("Fehler bei der Landkreiszuordnung", "Bitte wenden Sie sich an den Administrator", "error");
            return;
          }
          
          if(localStorage.getItem('feuerwehrenAngelegt') >= 3){
            Swal.fire("Es können maximal 3 Feuerwehren angelegt werden", "Bitte wenden Sie sich an den Administrator, wenn Sie weitere Feuerwehren anlegen möchten", "error");
            return;
          }

          axios.post('https://feuerwehr-server.org:5000/addFeuerwehr', feuerwehrData)
            .then(response => {
                console.log('Erfolgreich registrierte Feuerwehr:', response.data);
                Swal.fire("Feuerwehr erfolgreich angelegt", "Sie können sich nun mit einer Registrierung als Administrator Ihrer Feuerwehr anmelden", "success").then(() => {
                  if(localStorage.getItem('feuerwehrenAngelegt') !== null){
                    localStorage.setItem('feuerwehrenAngelegt', parseInt(localStorage.getItem('feuerwehrenAngelegt')) + 1);
                  }
                  else{
                    localStorage.setItem('feuerwehrenAngelegt', 1);
                  }
                  this.$emit('registerBack');
                });
            })
            .catch(error => {
                console.error('Fehler bei der Feuerwehrregistrierung:', error.response.data);
                Swal.fire("Es ist ein Fehler aufgetreten", "Bitte wenden Sie sich an den Administrator", "error");
            });
        },
        async getLandkreisID(){
          let typ = '';
          if(this.county === null || this.county === undefined || this.county === ''){
            this.county = this.city;
            typ = 'KS';
          }
          else{
            this.county = this.county.replace("Landkreis ", "");
            typ = 'LK';
          }
          const landkreisData = {
            name: this.county,
            typ: typ
          };
          try {
            const response = await axios.get(
              `https://feuerwehr-server.org:5000/landkreisByName/${landkreisData.name}/${landkreisData.typ}`
            );
            console.log(response);
            return response.data.landkreisID;
          } catch (error) {
            console.error('Fehler beim Abrufen der Landkreis-ID:', error);
            return null;
          }
        },
        encryptString(inputString){
            var encrypted = CryptopJS.AES.encrypt(inputString, "ökas893q5högha83pqthASKHG§Z(ERQZ)").toString();
            encrypted = encrypted.replace(/\//g, "z");
            encrypted = encrypted.replace(/:/g, "y");
            encrypted = encrypted.replace(/\./g, "9");
            return encrypted;
        },
    },
    async created(){
      
    }
}
</script>

<style lang="scss" scoped>
.createFeuerwehr {
  min-height: 100vh;
  width: 100vw;
  background-color: white;
  position: fixed;
  top: 0;
}

.flame{
    height: 4rem;
    display: block;
    position:fixed;
    right: 1rem;
    top: 1rem;
    z-index: 2;
}

.map{
    width: 90vw;
    margin-left: auto;
    margin-right: auto;
    max-height: 20rem;
    max-width: 25rem;
    height: 35vh;
    overflow: hidden;
    border-radius: 8px;
}

.back{
  width: 2.5rem;
  height: 2.5rem;
  border: solid rgb(236, 236, 236) 1px;
  background-color:white;
  border-radius: 8px;
  color: rgb(34, 34, 34);
  position: fixed;
  left: 2rem;
  top: 2rem;
  font-size: 1.5rem;
}

.back:hover{
  transform: scale(1.05);
}

h1{
  margin-top: 7rem;
  width: 90vw;
  margin-left: 5vw;
  margin-bottom: 3.5rem;
}

input, option, select{
  display: block;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  margin-bottom: 0.8rem;
  border: solid rgb(236, 236, 236) 1px;
  border-radius: 8px;
  background-color: rgb(248, 248, 248);
}

.createFeuerwehrButton{
  display: block;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  margin-top: 2rem;
  border: solid rgb(236, 236, 236) 1px;
  border-radius: 8px;
  background-color: rgb(0, 0, 0);
  color: white;
}

.createFeuerwehrButton:hover{
  transform: scale(1.02);
}

input, button, option, select{
  box-sizing: border-box;
  width: 90vw;
  max-width: 25rem;
  margin-left: auto;
  margin-right: auto;
}

.hasAccount {
  display: block;
  text-align: center;
  margin-top: 3.5rem;
  color: #888;
  position: absolute;
  bottom: 2rem;
  width: 100vw;
  left: 50%;
  transform: translate(-50%);
}

.hasAccountLink {
  color: #0a6ed1;
  cursor: pointer;
}

.hasAccountLink:hover{
  color: #094480;
}

.neueFeuerwehr{
  color: green;
}

.standortWaehlen{
    font-size: x-small;
}


// Gab bei Cordova builds Probleme
/*@media (max-height: 750px) {
    input, select, .registerButton{
        padding-top: 0.6rem !important;
        padding-bottom: 0.6rem !important;
        margin-bottom: 0.2rem;
        margin-top: 0.6rem !important;
    }

    h1{
      margin-bottom: 1rem;
      margin-top: 4.5rem;
    }

    .hasAccount{
      display: none;
    }
}*/
</style>
  
